/* react-onclickoutside is a deprecated package that should not be used for new
   code. Instead of having an outside click close a module, there should be an
   explicit close affordances in the spec. */
import OnClickOutside from "react-onclickoutside";
import { PropTypes } from "react";
import GrComponentFactory from "../gr_component_factory";
import BookSearch from "../search/book_search";

export default GrComponentFactory.createClass({
  displayName: "AddBookSearch",

  mixins: [OnClickOutside],

  propTypes: {
    onChooseResult: PropTypes.func.isRequired,
    search: PropTypes.shape({
      searchPath: PropTypes.string.isRequired,
      autocompleteUrl: PropTypes.string.isRequired,
    }).isRequired,
    onDismiss: PropTypes.func,
  },

  handleClickOutside() {
    if(this.props.onDismiss) {
      this.props.onDismiss();
    }
  },

  render() {
    const search = this.props.search;
    // Note: The BookSearch component is also called by nav_search, which has a different onChooseResult action.
    //       These should probably be separated into two separate components, with some shared styles and UI logic.
    return <BookSearch bemModifiers={this.props.bemModifiers}
                       searchPath={search.searchPath}
                       autocompleteUrl={search.autocompleteUrl}
                       onChooseResult={this.props.onChooseResult}
                       closeAfterResultChosen={true}/>;
  },
});
